import ConstrainBase from "../ConstrainBase";
import ValidationResult from "../ValidationResult";

/**
 * class DateTimeConstrain
 * Validiert Datums-/Zeitwerte im Format dd.mm.yyyy oder dd.mm.yyyy HH:MM
 * analog zur serverseitigen DateTimeConstrain.php
 */
class DateTimeConstrain extends ConstrainBase {

  validate(value) {
    if (value === null || value === undefined || value === '') {
      return new ValidationResult(true, '');
    }
    const str = String(value).trim();

    // Format: dd.mm.yyyy oder dd.mm.yyyy HH:MM
    const regex = /^(\d{2})\.(\d{2})\.(\d{4})( (\d{2}):(\d{2}))?$/;
    const match = str.match(regex);
    if (!match) {
      return new ValidationResult(false, 'Bitte das Format TT.MM.JJJJ (HH:MM) verwenden.');
    }

    const day = parseInt(match[1], 10);
    const month = parseInt(match[2], 10);
    const year = parseInt(match[3], 10);

    if (month < 1 || month > 12) {
      return new ValidationResult(false, 'Ungültiger Monat.');
    }
    // Prüfe ob Datum existiert (analog zu PHP checkdate)
    const date = new Date(year, month - 1, day);
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
      return new ValidationResult(false, 'Ungültiges Datum.');
    }

    if (match[5] !== undefined) {
      const hours = parseInt(match[5], 10);
      const minutes = parseInt(match[6], 10);
      if (hours > 23 || minutes > 59) {
        return new ValidationResult(false, 'Ungültige Uhrzeit.');
      }
    }

    return new ValidationResult(true, '');
  }
}

export default DateTimeConstrain;
